import { render, staticRenderFns } from "./DepositSummary.vue?vue&type=template&id=c28e0cc2&scoped=true&"
import script from "./DepositSummary.vue?vue&type=script&lang=js&"
export * from "./DepositSummary.vue?vue&type=script&lang=js&"
import style0 from "./DepositSummary.vue?vue&type=style&index=0&id=c28e0cc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28e0cc2",
  null
  
)

export default component.exports